import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MessageService, ToastService, AppConfigService } from 'web-ui';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  template: `<router-outlet />`,
  styles: [],
})
export class AppComponent implements OnDestroy {
  private subscription: Subscription;
  constructor(
    public translate: TranslateService,
    private messageService: MessageService,
    private toastService: ToastService,
    private appConfigService: AppConfigService
  ) {
    this.appConfigService.setBuildTarget(environment.buildTarget);
    this.appConfigService.setApiUrl(environment.apiUrl);

    translate.addLangs(['zh-CN', 'en-US', 'zh-TW', 'ru-RU']);
    translate.setDefaultLang('zh-CN');

    // 从localStorage获取用户选择的语言，如果没有则使用默认语言
    const savedLang = localStorage.getItem('selectedLanguage');
    translate.use(savedLang || 'zh-CN');

    this.subscription = this.messageService.message$.subscribe((msg) => {
      console.log('got message', msg);
      if (chrome.runtime) {
        chrome.runtime.sendMessage(msg);
      } else {
        this.toastService.error('未检测到插件运行时，请安装插件使用');
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
